<div class="userSitesDropdown">
  <button class="userSitesDropdown__button" (click)="toggleBulkHidden()">
    <span class="userSitesDropdown__buttonInner">
      <pp-icon
        ppColor="grey-600"
        ppClass="setSize18"
        class="userDropdownItem__icon"
        [ppSrc]="
          allWorkspacesVisible
            ? EIconPath.ICON_USER_GROUPS_HIDDEN_18
            : EIconPath.ICON_USER_GROUPS_VISIBLE_18
        "
      ></pp-icon>
      {{ (allWorkspacesVisible ? 'hide_all_sites' : 'show_all_sites') | ppTranslate }}
    </span>
  </button>

  <button class="userSitesDropdown__button" (click)="toggleBulkDigestSettings()">
    <span class="userSitesDropdown__buttonInner">
      <pp-icon
        ppColor="grey-600"
        ppClass="setSize18"
        class="userDropdownItem__icon"
        [ppSrc]="EIconPath.ICON_MISC_EDIT_14"
      ></pp-icon>
      {{ 'edit_all_notifications' | ppTranslate }}
    </span>
  </button>
</div>
